module.exports = __webpack_public_path__ + "img/security-code.115ea58e.svg";